/* unplugin-vue-components disabled */import script from "./OrderTableBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderTableBlock.vue?vue&type=script&setup=true&lang=ts"

import "./OrderTableBlock.vue?vue&type=style&index=0&id=95908adc&scoped=true&lang=less"
import "./OrderTableBlock.vue?vue&type=style&index=1&id=95908adc&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95908adc"]])

export default __exports__